import React from 'react';
import {Button, Group, Modal, Text} from "@mantine/core";
import {IconCircleX, IconThumbUp} from "@tabler/icons-react";

/**
 * Renders a confirmation modal asking the user to confirm or cancel approving an employee for a transaction team.
 *
 * @param txId - ID of the transaction team.
 * @param txTeamName - Display name of the transaction team.
 * @param approveModalOpen - Whether the modal is currently open.
 * @param closeApprovalModal - Callback to close the modal without approving.
 * @param toggleApproval - Callback invoked to confirm the approval.
 * @param employeeName - Display name of the employee being approved.
 */
const TransactionTeamApprovalModal = ({ txId, txTeamName, approveModalOpen, closeApprovalModal, toggleApproval, employeeName }) => {
    return (
        <>
            <Modal opened={approveModalOpen} onClose={closeApprovalModal} title='Confirm Approval' centered>
                <Text>{`You are approving ${employeeName} for Transaction Team "${txTeamName}". Please confirm your decision below.`}</Text>
                <Group>
                    <Button color='green' mt={20} rightSection={<IconThumbUp size={14} />} onClick={toggleApproval}>
                        Confirm
                    </Button>
                    <Button color='gray' mt={20} rightSection={<IconCircleX size={14} />} onClick={closeApprovalModal}>
                        Close
                    </Button>
                </Group>
            </Modal>
        </>
    );
};

export default TransactionTeamApprovalModal;
